export default __webpack_public_path__ + "static/media/2002.3c63cb65.png";